import { PortalCustomerItem } from '../../../Services/CompanyInformations/interfaces'

export enum ProducersListSize {
    Default = 0,
    Expanded = 1,
}

export type ProducersListProps = {
    items: PortalCustomerItem[]
    isSearched: boolean
}
